import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { ToastService, ToastType } from '../../services/toast.service';

@Component({
  selector: 'app-validate-email',
  templateUrl: './validate-email.component.html',
  styleUrls: ['./validate-email.component.css']
})
export class ValidateEmailComponent {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public loginService: LoginService,
    public toastService: ToastService,
  ) { }

  isButtonLoader: boolean = false;
  userId: string;
  // validateEmailFailed: boolean = false;

  ngOnInit() {
    this.isButtonLoader = true;
    this.route.queryParams
      .subscribe(params => {
        this.userId = params['userId'] ? params['userId'] : null;
      });
    if (this.userId) {
      this.loginService.VerifyEmail(this.userId).subscribe(
        {
          next: (res) => {
            this.isButtonLoader = false;

            if (res && (res.message == 'Email verified successfully' || res.message == 'Email is already verified')) {
              this.toastService.toast(res.message, ToastType.Information);
              this.router.navigateByUrl('');
            } else {
              this.toastService.toast('Email verification failed', ToastType.Error);
              this.router.navigateByUrl('');
            }
          },
          error: (err) => {
            this.isButtonLoader = false;
            this.toastService.toast('Email verification failed', ToastType.Error);
            this.router.navigateByUrl('');
          }
        }
      );
    }
  }

}
